// @flow
export * from './settings';
export * from './selectedItems';
export * from './updateVotes';
export * from './addUserInfo';
export * from './addEmailInfo';
export * from './auth';
export * from './setRegistredUserVotes';

export const GET_ITEM = {
	START: 'GET_ITEM.START',
	SUCCESS: 'GET_ITEM.SUCCESS',
	FAIL: 'GET_ITEM.FAIL',
};

export const GET_GALLERY_ITEMS = {
	START: 'GET_GALLERY_ITEMS.START',
	SUCCESS: 'GET_GALLERY_ITEMS.SUCCESS',
	FAIL: 'GET_GALLERY_ITEMS.FAIL',
};

export const SET_POP_UP = 'SET_POP_UP';
export const SAVE_SHARE_RESULT_TEXT = 'SAVE_SHARE_RESULT_TEXT';

export const SENT_EMAIL_INFO = {
	START: 'SENT_EMAIL_INFO.START',
	SUCCESS: 'SENT_EMAIL_INFO.SUCCESS',
	FAIL: 'SENT_EMAIL_INFO.FAIL',
};
